/*==============================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  -------------------------------
  
  
  
===============================*/

export default {
  users: []
}
